import {
  SET_IS_DELETING, SetIsDeleting,
  RemoveNotification, REMOVE_NOTIFICATION,
  NotificationsActions,
  SET_NOTIFICATIONS_IS_OPENED,
} from './Notifications.actions';
import { NotificationsState } from '../interfaces/NotificationsState';

const notificationReducer = (state: NotificationsState, action: NotificationsActions): NotificationsState => {
  switch (action.type) {
    case SET_IS_DELETING:
      return setIsDeleting(state, action);
    case REMOVE_NOTIFICATION:
      return removeNotification(state, action);
    case SET_NOTIFICATIONS_IS_OPENED:
      return setNotificationsIsOpened(state);
    default:
      return state;
  }
};

const setIsDeleting = (state: NotificationsState, action: SetIsDeleting): NotificationsState => {
  const notifications = state.notifications?.map(
    (notification) => notification.id === action.id ? { ...notification, isDeleting: action.isDeleting } : notification,
  );
  const promotions = state.promotions?.map(
    (promotion) => promotion.id === action.id ? { ...promotion, isDeleting: action.isDeleting } : promotion,
  );
  return {
    ...state,
    notifications,
    promotions,
  };
};

const removeNotification = (state: NotificationsState, action: RemoveNotification): NotificationsState => {
  const notifications = state.notifications?.filter((notification) => notification.id !== action.id || notification.isDeleting === false);
  const promotions = state.promotions?.filter((promotion) => promotion.id !== action.id || promotion.isDeleting === false);
  return {
    ...state,
    notifications,
    promotions,
  };
};

const setNotificationsIsOpened = (state: NotificationsState): NotificationsState => ({
  ...state,
  isOpened: !state.isOpened,
});

export default notificationReducer;
